<template>
  <modal
    class="modal-infrastructure-details"
    name="modal-infrastructure-details"
    :draggable="isMobile() ? false : '.modal-header'"
    width="800px"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t("inf.title") }}</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          @click="$modal.hide('modal-infrastructure-details');"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" v-if="loading">{{$t("inf.loading")}}</div>
      <div class="modal-body" v-else-if="this.dzialki.length == 0">{{$t("inf.noData")}}</div>
      <div class="modal-body" v-else>
        <div class="modal-body-select">
          <div>{{this.$t('inf.selectParcel')}}</div>
          <Multiselect
            class="select-parcel"
            v-model="dzialka"
            :options="dzialki"
            label="label"
            track-by="id"
          />
        </div>
        <div v-bar class="modal-body-scroll-parent">
          <div class="modal-body-scroll">
            <div class="inf-group" v-for="group in groups" :key="group.name">
              <table>
                <tbody>
                  <tr class="inf-heading">
                    <td colspan="2">{{ $t("inf.group."+group.prefix) }}</td>
                  </tr>
                  <tr class="inf-item" v-for="item in group.items" :key="item.name">
                    <td class="inf-desc">{{ $t("inf.item."+item.trans) }}</td>
                    <td class="inf-value">
                      <template
                        v-if="item.type === 'mozna_przylaczyc_enum'"
                      >{{ dzialka.properties[item.field] | showInLangPossibility(currlang) }}</template>
                      <template
                        v-else-if="typeof dzialka.properties[item.field] === 'boolean'"
                      >{{ dzialka.properties[item.field] | showInLangTrueFalse(currlang) }}</template>
                      <template
                        v-else-if="typeof dzialka.properties[item.field] === 'object'"
                      >{{ dzialka.properties[item.field] | showInLang(currlang) }}</template>
                      <template v-else>{{ dzialka.properties[item.field] }}</template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="inf-scroll-button wide-button nice-blue-background">{{this.$t('inf.scroll')}}</div>
      </div>
    </div>
  </modal>
</template>

<script>
import Multiselect from "vue-multiselect";
import GROUPS from "./InfrastructureDetailsGroups";

export default {
  components: {
    Multiselect
  },
  props: {
    currlang: String
  },
  data() {
    return {
      oferta: undefined,
      dzialki: undefined,
      dzialka: undefined,
      loading: true
    };
  },
  computed: {
    groups: () => GROUPS
  },
  methods: {
    beforeOpen(event) {
      let oferta = event.params.oferta;
      this.oferta = oferta;
      this.loading = true;
      this.$http
        .get(`/oferty_pub/oferta/${oferta.id}/infrastruktura`)
        .then(r => {
          let dzialki = r.data.item.dzialki.features;
          dzialki.sort((a, b) => b.id - a.id);
          this.dzialki = dzialki;

          this.dzialki.forEach(dzialka => {
            dzialka.label = dzialka.properties.numer;
          });
          if (this.dzialki.length > 0) {
            this.dzialka = this.dzialki[0];
          }
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
          console.error(e);
          alert("Details downloading error");
        });
    }
  }
};
</script>

<style lang="scss">
.modal-infrastructure-details {
  .select-parcel {
    border: 1px solid gray;
  }

  .modal-body-scroll-parent {
    margin: 10px 0;

    .vb-dragger {
      width: 20px;
    }

    .modal-body-scroll {
      border: 1px solid gray;
      padding: 0 10px;
      scroll-behavior: auto;
      max-height: 50vh;
      overflow: auto;

      .inf-heading {
        font-size: 1em;
      }

      .inf-group {
        padding-top: 20px;
      }

      td {
        padding: 5px 10px;
      }
    }
  }

  .inf-scroll-button {
    cursor: default;

    text-align: center;
  }
}
</style>
